import { Drawer } from "vaul";
import clsx from "clsx";
import { PhoneIncoming, Smartphone, Mail } from "lucide-react";

import { APP_LANGUAGES, APP_STRINGS_LABELS, getAppStringForLanguage } from "utils/language";

const Contact = ({ language = APP_LANGUAGES.ENGLISH }: { language?: APP_LANGUAGES }) => {
  return (
    <>
      <Drawer.Root>
        <Drawer.Overlay className="fixed inset-0 z-40 bg-gray-100 bg-opacity-10 backdrop-blur" />
        <Drawer.Trigger>{getAppStringForLanguage(APP_STRINGS_LABELS.CONTACT_US, language)}</Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Content
            className={clsx(
              "fixed bottom-0 left-0 right-0 z-50 mt-24 rounded-t-[10px] border-t border-gray-200 bg-primary-700 px-2 text-white"
            )}
          >
            <div className="p-2 md:p-20">
              <div className=" p-4 text-center text-white">
                <h2 className="text-3xl font-medium">
                  {getAppStringForLanguage(APP_STRINGS_LABELS.QUESTIONS_JUST_ASK, language)}
                </h2>
                <p className="font-matter text-xl !text-white">
                  {getAppStringForLanguage(APP_STRINGS_LABELS.QUESTIONS_LET_ME_KNOW, language)}
                </p>
              </div>

              <div className="px-4 md:px-12">
                <div className="grid grid-cols-1 gap-4 text-center font-matter text-white md:grid-cols-3 md:gap-8 ">
                  <div className="m-2 rounded-xl p-2 md:mb-4 md:bg-[rgba(255,255,255,0.06)] md:p-4">
                    <span className="mb-1 inline-flex h-10 w-10 shrink-0 items-center  justify-center rounded-full  bg-primary-700 md:mb-6 md:h-16 md:w-16">
                      <PhoneIncoming
                        strokeWidth={1}
                        size={28}
                        absoluteStrokeWidth
                        className="h-6 w-6 text-white md:h-10 md:w-10"
                      />
                    </span>
                    <h3 className="mb-2 text-lg font-medium md:mb-2 md:text-xl">
                      {getAppStringForLanguage(APP_STRINGS_LABELS.CALL_ME, language)}
                    </h3>
                    <a
                      href={`tel:${getAppStringForLanguage(APP_STRINGS_LABELS.SOLDAVE_NUMBER_E164, language)}`}
                      className="text-center text-md font-medium text-white underline underline-offset-4 md:text-xl"
                    >
                      {getAppStringForLanguage(APP_STRINGS_LABELS.SOLDAVE_NUMBER, language)}
                    </a>
                  </div>

                  <div className="m-2 rounded-xl p-2 md:mb-4 md:bg-[rgba(255,255,255,0.06)] md:p-4">
                    <span className="mb-1 inline-flex h-10 w-10 shrink-0 items-center  justify-center rounded-full  bg-primary-700 md:mb-6 md:h-16 md:w-16">
                      <Smartphone
                        strokeWidth={1}
                        size={28}
                        absoluteStrokeWidth
                        className="h-6 w-6 text-white md:h-10 md:w-10"
                      />
                    </span>
                    <h3 className="mb-2 text-lg font-medium md:mb-2 md:text-xl">Text me</h3>
                    <a
                      href={`tel:${getAppStringForLanguage(APP_STRINGS_LABELS.SOLDAVE_NUMBER_E164, language)}`}
                      className="text-center text-md font-medium text-white underline underline-offset-4 md:text-xl"
                    >
                      {getAppStringForLanguage(APP_STRINGS_LABELS.SOLDAVE_NUMBER, language)}
                    </a>
                  </div>

                  <div className="m-2 rounded-xl p-2 md:mb-4 md:bg-[rgba(255,255,255,0.06)] md:p-4">
                    <span className="mb-1 inline-flex h-10 w-10 shrink-0 items-center  justify-center rounded-full  bg-primary-700 md:mb-6 md:h-16 md:w-16">
                      <Mail
                        strokeWidth={1}
                        size={28}
                        absoluteStrokeWidth
                        className="h-6 w-6 text-white md:h-10 md:w-10"
                      />
                    </span>
                    <h3 className="mb-2 text-lg font-medium md:mb-2 md:text-xl">Email me</h3>
                    <a
                      href="mailto:hi@soldave.com"
                      className="text-center text-md font-medium text-white underline underline-offset-4 md:text-xl"
                    >
                      vip@soldave.com
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </>
  );
};

export default Contact;
